import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'
import Spinner from '../Spinner'

interface SubmitButtonProps {
  disabled?: boolean
  anyLoading?: boolean
  widthFull?: boolean
  text: string
}
export function SubmitButton ({ text, anyLoading = false, disabled = false, widthFull = false }: SubmitButtonProps): ReactElement {
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <button
      type="submit"
      className={cn(
        buttonColors.classes,
        widthFull ? 'w-full' : 'w-48',
        'flex justify-center py-2 px-4 mb-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2'
      )}
      disabled={disabled}
    >
      {
              anyLoading
                ? (<Spinner additionalClasses="-ml-1 mr-3" />)
                : text
          }
    </button>
  )
}
